module.exports = __webpack_public_path__ + "img/bg-new-1.02cf1d3b.png";